import { render, staticRenderFns } from "./GridCentro.vue?vue&type=template&id=57c6ba61&"
import script from "./GridCentro.vue?vue&type=script&lang=js&"
export * from "./GridCentro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports